// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 438) return "static/chunks/7af2d8d5-91a358a46494d833.js";
	if (chunkId === 867) return "static/chunks/867-c7138249919f1b9b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"3fee9c18df7525be","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"d0cf5ef052fee87a","367":"62752f9cbfed009e","639":"7e1b22c1eaec6b80","748":"b2d25cad79c2fa15"}[chunkId] + ".js";
};